import React, { ReactElement } from 'react';

import { useBoolean } from '@dreryk/react-common';

import { TimetablePreferencesModal } from './TimetablePreferencesModal';
import { TimetablePreferencesModalOpenIcon } from './TimetablePreferencesModalOpenIcon';

type TimetablePreferencesModalChildrenRenderProps = {
   closeModal: VoidFunction;
};

type TimetablePreferencesModalProps = {
   children: (renderProps: TimetablePreferencesModalChildrenRenderProps) => ReactElement;
};

export const TimetablePreferencesModalOpener = (props: TimetablePreferencesModalProps): ReactElement => {
   const [{ setTrue: openModal, setFalse: closeModal }, modalOpened] = useBoolean();
   return (
      <>
         {modalOpened ? (
            <TimetablePreferencesModal onClose={closeModal}>
               {props.children({ closeModal: closeModal })}
            </TimetablePreferencesModal>
         ) : null}
         <TimetablePreferencesModalOpenIcon onClick={openModal} />
      </>
   );
};
